// extracted by mini-css-extract-plugin
export default {"button":"_21OrUxFwHXyh1JGkBMA7qV"};